import axios from 'axios'
import React, { useEffect, useState, useCallback, useRef } from 'react'
import Loader from '../Loader';
import AuthModal from './AuthModal';
import RegistrationModal from './RegistrationModal';

function Modal({setIsAtiveModal, openModal}) {

    const escFunction = useCallback((event) => {
        if (event.key === 'Escape') {
            setIsAtiveModal(false);
        }
      }, []);
    
      useEffect(() => {
        document.addEventListener('keydown', escFunction, false);
    
        return () => {
          document.removeEventListener('keydown', escFunction, false);
        };
      }, []);

    const checkFormHandler = (e)=> {
        e.stopPropagation()
    }

    return (
        <div className="active-modal" onClick={()=>setIsAtiveModal(false)}>
            <form className='interface_border modal_form__wrapper' onClick ={(e)=>checkFormHandler(e)}>
                <span className='_modal_product__close' onClick={()=>setIsAtiveModal(false)}></span>
            {
                openModal === 'auth' ?
                <AuthModal/>
                :
                <RegistrationModal/>
            }
            
            </form>
        </div>
  )
}

export default Modal